import AthubCloudApi from '@/api/athubCloud/index'
import { from } from 'rxjs';

export default {

    namespaced: true,

    state: {

        sysroomSource$: {}

    },

    getters: {

        sysroomSource$(state) {
            return state.sysroomSource$;
        },

    },

    mutations: {
        setSysroomSource(state, payload) {
            state.sysroomSource$ = payload;
        },

    },

    actions: {

        getSysroomSource({commit}, payload) {
            commit("setSysroomSource", from(AthubCloudApi.getRoomsByAuthSites()));
        },

        getAllSysroomSource({commit}, payload) {
            commit("setSysroomSource", from(AthubCloudApi.getAllRooms()));
        }

    },

}